import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { first } from 'rxjs/operators';

import { User } from '../../../model/user';
import { AuthenticationService } from '../../../service/authentication.service';
import { UserSessionService } from '../../../_client-service/user-session.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    loginForm: any = {};
    user: User;
    loading = false;
    submitted = false;
    error: any;

    constructor(
        // private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        private userSessionSrv: UserSessionService
    ) { }

    ngOnInit() {
        this.userSessionSrv.onUserChange.subscribe((user: User) => this.user = user);
    }


    login() {
        this.submitted = true;
        this.loading = true;
        this.user = new User();
        this.user.email = this.loginForm.email;
        this.user.password = this.loginForm.password;
        this.authenticationService.login(this.user)
            .pipe(first())
            .subscribe(
                data => {
                    this.user = data;
                    this.userSessionSrv.setUser(data);
                    if (this.user.defaultPasswordChanged === 'N') {
                        this.router.navigate(['/cambio-password']);
                    } else {
                        this.router.navigate(['/p']);
                    }
                },
                error => {
                    this.error = error.error;
                    this.loading = false;
                }
            );
    }

    resetFormValidation() {
        this.error = null;
    }

}
